import api from 'api'
import { pathOr } from 'ramda'

export interface UserW2I9Form {
  userId: number
  firstName: string
  lastName: string
  middleName?: string
  dob: string
  citizenshipStatus: 'permanent-resident' | 'citizen' | 'non-citizen'
  uscis?: string
  documentListType: string
  submittedAt: string
  verifiedAt?: string
  processedAt?: string
  startDate?: string
  ssn: string
  market: string
  w2State: string
  documents: UserW2I9Document[]
  requiresEVerifyNote?: boolean
}

export interface UserW2I9Document {
  documentUrl: string
  documentName: string
}

export interface UnprocessedEVerifyI9Form {
  userId: number
  firstName: string
  lastName: string
  market: string
  mailingState: string
  submittedAt: string
  requiresEVerifyNote?: boolean
}

export async function getUserW2I9Form(userId: number) {
  const response = await api.post(
    '/admin/graphql_dispatch/user_w2_i9_form_141904dd',
    {
      userId,
    }
  )
  return pathOr(
    null,
    ['data', 'admin', 'userW2I9Form'],
    response.data
  ) as UserW2I9Form | null
}

export async function getUnprocessedI9Forms(params?: {
  market?: string
  mailingState?: string
}) {
  const response = await api.post(
    '/admin/graphql_dispatch/unprocessed_everify_i9_forms_a0a035bb',
    {
      ...(params?.market && { market: params.market }),
      ...(params?.mailingState && { mailingState: params.mailingState }),
    }
  )

  return {
    unprocessedEVerifyI9Forms: pathOr(
      [],
      ['data', 'admin', 'unprocessedEVerifyI9Forms'],
      response.data
    ) as UnprocessedEVerifyI9Form[],
    availableMarkets: pathOr(
      [],
      ['data', 'admin', 'availableMarkets'],
      response.data
    ) as string[],
    availableMailingStates: pathOr(
      [],
      ['data', 'admin', 'availableMailingStates'],
      response.data
    ) as string[],
  }
}

export function processUserI9Documents(userId: number) {
  return api.post(`/admin/user/${userId}/i9_documents/process`)
}
